import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import type { GetCurrentStorageUsageQuery as GetCurrentStorageUsageQueryType } from './__types__/GetCurrentStorageUsageQuery';
import { GetCurrentStorageUsageQuery } from './GetCurrentStorageUsage.graphql';

export const preloadStorageEnforcementBanner = () =>
	query<GetCurrentStorageUsageQueryType, {}>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: GetCurrentStorageUsageQuery,
	});
